'use client';

import { Liff } from '@line/liff';
import { createContext } from 'react';

import type { Profile } from '@liff/get-profile';

interface GlobalContextType {
  liff: Liff | null;
  liffProfile: Profile | null;
  liffError: string | null;
}

export const GlobalContext = createContext<GlobalContextType | undefined>(
  undefined
);
